module.exports = "<p *ngIf=\"errorObj?.hasErrors === true\" id=\"bottom-page-errors\">{{errorBody}}</p> ";